module.exports = __webpack_public_path__ + "static/chip_xl-3602be6838b8436c0de9aee5d187e4d9.svg";